// @ts-nocheck
import React from 'react';
import { useRequestQuery } from '../../useQueryRequest';
import { useDownloadFile } from '../../useDownloadFile';
import { useRequestPdf } from '../../useRequestPdf';
import useApiRequest from '../../useRequest';
import t from '../types';

/**
 * Retrieve BIR 2550 report.
 */
export function useBIR2550(query, props) {
  return useRequestQuery(
    [t.FINANCIAL_REPORT, t.BIR_2550, query],
    {
      method: 'get',
      url: '/financial_statements/bir-2550',
      params: query,
    },
    {
      ...props,
    },
  );
}

/**
 * Retrieves BIR 2550 table format.
 */
export function useBIR2550Table(query, props) {


  return useRequestQuery(
    [t.FINANCIAL_REPORT, t.BIR_2550, query],
    {
      method: 'get',
      url: '/financial_statements/bir-2550',
      params: query,
      headers: {
        Accept: 'application/json+table',
      },
    },
    {
      select: (res) => {
        // The backend returns { data: { table: { rows: [...] }, query: {...}, meta: {...} } }
        // So we need to return res.data.data instead of res.data
        return res.data.data;
      },
      ...props,
    },
  );
}

export const useBIR2550CsvExport = (query, args) => {
  return useDownloadFile({
    url: '/financial_statements/bir-2550',
    config: {
      headers: {
        accept: 'application/csv',
      },
      params: query,
    },
    filename: 'bir_2550q_report.csv',
    ...args,
  });
};

export const useBIR2550XlsxExport = (query, args) => {
  return useDownloadFile({
    url: '/financial_statements/bir-2550',
    config: {
      headers: {
        accept: 'application/xlsx',
      },
      params: query,
    },
    filename: 'bir_2550q_report.xlsx',
    ...args,
  });
};

export const useBIR2550PdfExport = (query, args) => {
  return useRequestPdf({
    url: '/financial_statements/bir-2550',
    config: {
      params: query,
    },
    filename: 'bir_2550q_report.pdf',
    ...args,
  });
};

/**
 * Retrieves BIR 2550 PDF URL for preview.
 */
export function useBIR2550Pdf(query = {}) {
  return useRequestPdf({
    url: `/financial_statements/bir-2550`,
    params: query,
  });
}
